// Converts a string of the form '2019-12-01' to 'December 2019'

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const rxDateFormat = /^(\d{4})-(\d{1,2})-.*$/

export const formatDateString = str => str.replace(rxDateFormat, (match, year, month) => `${MONTHS[month - 1]} ${year}`)
